import { Flex, Input, InputNumber } from "antd";
import React from "react";

const CustomInput = ({
  title,
  placeholder = "-",
  value,
  onChange,
  style,
  onKeyDown,
  autoFocus = false,
  prefix,
  suffix,
  required,
  type = "input",
  maxLength,
  readOnly = false,
  allowClear = false,
  step,
  min,
  formatter,
  parser,
}) => {
  return (
    <Flex vertical gap={"2px"} style={{ width: "100%" }}>
      {title && (
        <p style={{ fontSize: "13px" }}>
          {required && <span style={{ color: "#f00" }}>*</span>}
          {title}:
        </p>
      )}
      {type === "inputNumber" ? (
        <InputNumber
          readOnly={readOnly}
          min={min || 0}
          step={step}
          defaultValue={0}
          style={{
            ...style,
            minHeight: "40px",
            padding: "5px 0",
            width: "100%",
          }}
          value={value}
          onChange={onChange}
          formatter={formatter}
          parser={parser}
        />
      ) : (
        <Input
          allowClear={allowClear}
          readOnly={readOnly}
          placeholder={placeholder ?? "-"}
          value={value}
          onChange={onChange}
          style={{ ...style, minHeight: "40px" }}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
          prefix={prefix}
          suffix={suffix}
          maxLength={maxLength}
          // disabled={readOnly}
        />
      )}
    </Flex>
  );
};

export default CustomInput;
